import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import PaiButton from 'features/ui/base-components/pai-button';
import PaiLink from 'features/ui/base-components/pai-link';
import PaiMenuItem from 'features/ui/base-components/pai-menu-item';
import PaiSelect from 'features/ui/base-components/pai-select';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  open: boolean;
  language: string;
  loading: boolean;

  handleLanguageChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handleClose(): void;

  handleAcceptLanguage(): void;
}

const ReportLanguageDialog: React.FC<Props> = ({ open, language, loading, handleLanguageChange, handleClose, handleAcceptLanguage }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const languages = [
    { label: 'Deutsch', value: 'de' },
    { label: 'Englisch', value: 'en' },
  ];

  return (
    <Dialog open={open} classes={{ paper: classes.paper }} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>Sprache des Berichts</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={1}>
          <Typography className={classes.instructionTitle}>In welcher Sprache soll der Bericht erstellt werden?</Typography>
          <PaiSelect onChange={handleLanguageChange} value={language}>
            {languages.map((option) => (
              <PaiMenuItem key={option.value} value={option.value}>
                {option.label}
              </PaiMenuItem>
            ))}
          </PaiSelect>
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton text={t('ok')} action={handleAcceptLanguage} loading={loading} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: 0,
  },
  title: {
    background: theme.palette.primary.main,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '16px !important',
    whiteSpace: 'pre-wrap',
  },
  instructionTitle: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 'bold',
    textDecoration: 'underline',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default ReportLanguageDialog;
